import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 12l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007h-4l-.15 -.005a2 2 0 0 1 -1.844 -1.838l-.006 -.157v-4l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007h-9a3 3 0 0 0 -2.995 2.824l-.005 .176v10a3 3 0 0 0 2.824 2.995l.176 .005h14a3 3 0 0 0 2.995 -2.824l.005 -.176z","key":"svg-0"}],["path",{"d":"M17 5v4l4.001 .001z","key":"svg-1"}]]

const IconFileHorizontalFilled = createReactComponent('filled', 'file-horizontal-filled', 'FileHorizontalFilled', __iconNode);

export default IconFileHorizontalFilled;